export function selectHeaderLinkBack(state) {
  return state.headerLinkBack.payload || {};
}
